module.exports = __webpack_public_path__ + "media/images/apple_store-1a4cc50b05a17d1bccb99554ada31aa2.png";